export const SYNC_KEY = (partner) => '_iiq_sync' + '_' + partner
